<template>
  <template
    v-for="(part, index) in parts"
    :key="index"
  >
    <code
      v-if="part.type === 'code'"
      class="ai-inline-code"
      v-text="part.value"
    />
    <strong
      v-else-if="part.type === 'strong'"
      v-text="part.value"
    />
    <em
      v-else-if="part.type === 'em'"
      v-text="part.value"
    />
    <!-- Chemin de l'application : navigation interne, sans rechargement. -->
    <router-link
      v-else-if="part.type === 'link' && !part.external"
      :to="part.href"
      class="ai-inline-link"
    >
      <!-- Le libellé passe par un span : `v-text` sur un composant en écraserait
           le contenu, et l'interpoler ici ajouterait des espaces au soulignage. -->
      <span v-text="part.value" />
    </router-link>
    <!-- Adresse extérieure : nouvel onglet, et `noopener` pour que la page
         ouverte ne puisse pas reprendre la main sur celle-ci. -->
    <a
      v-else-if="part.type === 'link'"
      :href="part.href"
      class="ai-inline-link"
      target="_blank"
      rel="noopener noreferrer"
      v-text="part.value"
    />
    <!-- `v-text` sur un span et non une interpolation : la mise en forme du
         template ajouterait des espaces au milieu des phrases. -->
    <span
      v-else
      v-text="part.value"
    />
  </template>
</template>

<script setup>
/**
 * Rend les fragments d'une ligne : gras, italique, code, texte.
 *
 * Chaque valeur est posée en `v-text` ou par interpolation, donc en contenu
 * textuel. Les balises viennent d'ici, jamais du modèle : rien de ce qu'il
 * renvoie ne peut être interprété comme du HTML.
 */
defineProps({
  parts: {
    type: Array,
    default: () => [],
  },
});
</script>

<style scoped>
.ai-inline-link {
  color: var(--el-color-primary);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.ai-inline-code {
  padding: 0.1em 0.35em;
  border-radius: 4px;
  background: var(--el-fill-color-darker, #f4f4f5);
  border: 1px solid var(--el-border-color-lighter);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.9em;
  word-break: break-all;
}
</style>
